import React from "react";
import Bach from "../../components/bach/Bach";
import lms from "../../assets/images/home/lms.svg";
import time from "../../assets/images/home/time.svg";
import test from "../../assets/images/home/test.svg";
import report from "../../assets/images/home/report.svg";
import cost from "../../assets/images/home/cost.svg";
import platform from "../../assets/images/home/platform.svg";
import india from "../../assets/images/home/indea.svg";
import solution from "../../assets/images/home/solution.svg";
import management from "../../assets/images/home/management.svg";
import support from "../../assets/images/home/support.svg";
import chooseUsSection from "../../assets/images/home/chooseUsSection.webp";

const benefits = [
  {
    icon: time,
    title: (
      <span>
        <strong> Real-time </strong> Rehearsals
      </span>
    ),
  },
  {
    icon: india,
    title: (
      <span>
        <strong> Pan-India</strong> Presence
      </span>
    ),
  },
  {
    icon: platform,
    title: (
      <span>
        Smart Tech, <strong> One Platform</strong>
      </span>
    ),
  },
  {
    icon: management,
    title: (
      <span>
        Instant
        <strong>Results & Insights</strong>
      </span>
    ),
  },
  {
    icon: support,
    title: (
      <span>
        Dedicated <strong>Support & Onboarding </strong>
      </span>
    ),
  },
  {
    icon: solution,
    title: (
      <span>
        Custom
        <strong>Branded Solutions</strong>
      </span>
    ),
  },
];

export default function WhyChooseUs() {
  return (
    <section className="md:py-16 py-8 px-4 md:px-12 bg-[#fffaf6]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Left Content */}
        <div>
          <Bach>The Smart Choice for Serious Preparation</Bach>
          <h2 className="text-2xl md:text-3xl mb-4">
            Why Choose Us
            <span className="flex items-center gap-1 mt-1">
              <span className="w-10 h-[2px] bg-gray-400"></span>
              <span className="w-2 h-[2px] bg-gray-400"></span>
              <span className="w-6 h-[2px] bg-gray-400"></span>
            </span>
          </h2>

          <p className="font-outfitRegular leading-relaxed mb-6 text-base">
            At Edupro Hub, we don't just provide digital tools—we deliver
            the <strong> Real Exam Experience </strong> your students need to succeed. From <strong> Test
            Center Simulations </strong> to  <strong>Smart LMS Integration</strong>, everything is designed
            to help your coaching institute grow, scale, and <strong> Deliver real
            Results.</strong>
          </p>

          {/* Placeholder floating boxes */}
          {/* <div className="mt-12 relative">
            <div className="w-60 h-28 bg-white rounded-md shadow-2xl -mb-12 ml-32 z-20 relative"></div>

            <div className="flex gap-6">
              <div className="w-48 h-40 bg-white rounded-md shadow-2xl relative z-10"></div>
              <div className="w-48 h-40 bg-white rounded-md shadow-2xl mt-16 relative z-10"></div>
            </div>
          </div> */}
          <div className="mt-12">
            <img
              src={chooseUsSection}
              alt="chooseUsSection"
              className="h-72 m-auto"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>

        {/* Right Content - Benefits */}
        <div>
          <div className="bg-[#F5F5F5] font-outfitRegular py-2 px-4 rounded-lg text-center mb-4 uppercase">
            What Sets Us Apart:
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition duration-300 flex items-start gap-3"
              >
                <div className="w-[20%]">
                  <img
                    src={benefit.icon}
                    className="w-12 h-8 bg-[#F5F5F5] p-1.5 rounded-md"
                    alt=""
                  />
                </div>
                <div>
                  <p className="font-outfitRegular text-sm text-black">
                    {benefit.title}
                  </p>
                  {/* {benefit.desc && (
                    <p className="text-xs text-gray-600">{benefit.desc}</p>
                  )} */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
